<template>
  <div class="external-withdraw-params">
    <iframe :src="url" class="frame" />
  </div>
</template>

<script>
export default {
  props: {
    // Outside url (Mercuryo) for showing to user
    url: String,
  },

  methods: {
    receiveMessage(event) {
      if (event?.data?.type !== 'MercuryoSellResult') return
      const isSellSuccess = Boolean(event?.data?.isSellSuccess)
      const address = event?.data?.address
      const signature = event?.data?.signature

      if (isSellSuccess) {
        this.$emit('mercuryo-sell-success', {
          address,
          signature,
        })
      } else {
        this.$emit('mercuryo-sell-fail')
      }
    },
  },

  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },

  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage, false)
  },
}
</script>

<style scoped lang="scss">
.frame {
  margin-top: 30px;
  width: 100%;
  height: 600px;
  border: none;
}
</style>
